import i18n from '@/i18n'

export default [
    {
        value: 'Jan',
        label: i18n.t('months.january.short'),
    },
    {
        value: 'Feb',
        label: i18n.t('months.february.short'),
    },
    {
        value: 'Mar',
        label: i18n.t('months.march.short'),
    },
    {
        value: 'Apr',
        label: i18n.t('months.april.short'),
    },
    {
        value: 'May',
        label: i18n.t('months.may.short'),
    },
    {
        value: 'Jun',
        label: i18n.t('months.june.short'),
    },
    {
        value: 'Jul',
        label: i18n.t('months.july.short'),
    },
    {
        value: 'Aug',
        label: i18n.t('months.august.short'),
    },
    {
        value: 'Sep',
        label: i18n.t('months.september.short'),
    },
    {
        value: 'Oct',
        label: i18n.t('months.october.short'),
    },
    {
        value: 'Nov',
        label: i18n.t('months.november.short'),
    },
    {
        value: 'Dec',
        label: i18n.t('months.december.short'),
    },
]